import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EstudioComponent } from './estudio.component';
import { EstudioResumenComponent } from './resumen/estudio-resumen.component';
import { EstudioResumenResolver } from './resumen/estudio-resumen-resolver.service';
import { EstudioMapaCurricularComponent } from './mapa-curricular/mapa-curricular.component';
import { CursosResolver } from './_resolvers/cursos-resolver.service';
import { MapaCurricularBusquedaComponent } from './mapa-curricular/mapa-curricular-busqueda.component';
import { AreasResolver } from './_resolvers/areas-resolver.service';
import { CategoriasMetasResolver } from './_resolvers/categorias-resolver.service';
import { AmbitosResolver } from './_resolvers/ambitos-resolver.service';
import { TagsResolver } from './_resolvers/tags-resolver.service';
import { ProfesoresResolver } from './_resolvers/personas-resolver.service';
import { MateriasPeriodoResolver } from './_resolvers/materias-periodo-resolver.service';
import { UnidadEtapasComponent } from './unidad-etapas/unidad-etapas.component';
import { CategoriasUnidadResolver } from './_resolvers/categorias-unidad-resolver.service';
import { PeriodosResolver } from './_resolvers/periodos-resolver.service';
import { AsistenciaCursoComponent } from '../asistencia/asistencia-curso/asistencia-curso.component';
import { UnidadFamiliaComponent } from './unidad-familia/unidad-familia.component';
import { MateriasFamiliaComponent } from './materias-familia/materias-familia.component';
import { FamiliaHijoComponent } from './familia-hijo/familia-hijo.component';
import { NivelacionesHijoComponent } from '../nivelaciones/nivelaciones-hijo/nivelaciones-hijo.component';
import { RetroalimentacionListaAlumnosComponent } from './retroalimentacion/retroalimentacion-lista-alumnos/retroalimentacion-lista-alumnos.component';
import { RetroalimentacionEvaluacionComponent } from './retroalimentacion/retroalimentacion-evaluacion/retroalimentacion-evaluacion.component';
import { RetroalimentacionAlumnoComponent } from './retroalimentacion/retroalimentacion-alumno/retroalimentacion-alumno.component';
import { DashboardRetroalimentacionComponent } from './retroalimentacion/dashboard/dashboard.component';
import { AuthGuard } from '../../_guards';
import { RetroalimentacionMisMateriasComponent } from './retroalimentacion/retroalimentacion-mis-materias/retroalimentacion-mis-materias.component';
import { McpResolver } from './_resolvers/mcp-resolver.service';
import { MapaGeneradoComponent } from './mapa-curricular/mapa-generado/mapa-generado.component';
import { RetroalimentacionGridComponent } from './retroalimentacion/retroalimentacion-grid/retroalimentacion-grid.component';
import { AutoevaluacionComponent } from './autoevaluacion/autoevaluacion.component';
import { RetroalimentacionReportComponent } from './retroalimentacion-report/retroalimentacion-report.component';

const estudioRoutes: Routes = [
  // {
  //   path: 'resumen/:idPeriodo',
  //   component: EstudioResumenComponent
  // },
  // {
  //   path: 'resumen',
  //   component: EstudioResumenComponent
  // },
  {
    path: 'mapa-curricular/materias/:idsMateria/cursos/:idsCurso',
    component: MapaGeneradoComponent,
    resolve: {
      cursos: CursosResolver,
      areas: AreasResolver,
      categoriasMetas: CategoriasMetasResolver,
      ambitos: AmbitosResolver,
      tags: TagsResolver,
      profesores: ProfesoresResolver,
      materiasPeriodo: MateriasPeriodoResolver,
      periodos: PeriodosResolver
      // alumnosIEP: AlumnosIEPResolver
    },
    children: [
      {
        path: 'busqueda',
        component: MapaCurricularBusquedaComponent,
        outlet: 'mc-sidebar'
      }
    ]
  },
  {
    path: 'mapa-curricular',
    component: EstudioMapaCurricularComponent,
    resolve: {
      cursos: CursosResolver,
      areas: AreasResolver,
      categoriasMetas: CategoriasMetasResolver
    },
    children: [
      {
        path: 'busqueda',
        component: MapaCurricularBusquedaComponent,
        outlet: 'mc-sidebar'
      }
    ]
  },
  {
    path: 'unidad/:id',
    component: UnidadEtapasComponent,
    // resolve: {
    //   areas: AreasResolver,
    //   ambitos: AmbitosResolver,
    //   categorias: CategoriasUnidadResolver,
    //   cursos: CursosResolver,
    //   materiasPeriodo: MateriasPeriodoResolver,
    //   profesores: ProfesoresResolver,
    //   tags: TagsResolver,
    //   // unidad: UnidadEtapasResolver,
    //   periodos: PeriodosResolver
    // },
    children: [
      {
        path: 'evaluacion/:eventoUnidadID/materia/:materiaID/alumnos/:alumnosIDS',
        component: RetroalimentacionEvaluacionComponent,
        outlet: 'retroalimentacion'
      },
      {
        path: 'retroalimentacion/:eventoUnidadID/materia/:materiaID',
        component: RetroalimentacionListaAlumnosComponent,
        outlet: 'retroalimentacion'
      },
      {
        path: 'retroalimentacion/:eventoUnidadID',
        component: RetroalimentacionListaAlumnosComponent,
        outlet: 'retroalimentacion'
      },
    ]
  },
  {
    path: 'unidad/:unidadId/retroalimentacion/evento/:eventoUnidadId',
    component: RetroalimentacionGridComponent,
  },
  {
    path: 'unidad/:unidadId/retroalimentacion/evento/:eventoUnidadId/materia/:materiaId',
    component: RetroalimentacionGridComponent
  },
  {
    path: 'autoevaluacion/eventoMateria/:eventoMateriaId/alumno/:alumnoId',
    component: AutoevaluacionComponent
  },
  {
    path: 'familia',
    resolve: {
      periodos: EstudioResumenResolver
    },
    children: [
      {
        path: 'alumno/:hijoID',
        component: FamiliaHijoComponent,
        children: [
          {
            path: 'materias/periodo/:periodoID',
            component: MateriasFamiliaComponent
          },
          {
            path: 'materias',
            component: MateriasFamiliaComponent
          },
          // {
          //   path: 'nivelaciones/mes/:mesID',
          //   component: NivelacionesHijoComponent
          // },
          // {
          //   path: 'nivelaciones',
          //   component: NivelacionesHijoComponent
          // },
          {
            path: 'unidad/:id',
            component: UnidadFamiliaComponent,
            resolve: {
              categorias: CategoriasUnidadResolver
            },
            children: [
              {
                path: 'evento/:eventoUnidadID',
                component: RetroalimentacionAlumnoComponent,
                outlet: 'retroalimentacionalumno'
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'retroalimentacion',
    children: [
      {
        path: 'dashboard/materia/:materiaID/alumno/:alumnoID',
        component: DashboardRetroalimentacionComponent
      },
      {
        path: 'dashboard/materia/:materiaID',
        component: DashboardRetroalimentacionComponent
      },
      {
        path: 'materias/alumno/:alumnoID',
        component: RetroalimentacionMisMateriasComponent
      },
      {
        path: 'materias',
        component: RetroalimentacionMisMateriasComponent
      }
    ]
  },
  {
    path: 'asistencia/curso/:mcpID/fecha/:fecha',
    component: AsistenciaCursoComponent
  },
  {
    path: 'asistencia/curso/:mcpID',
    component: AsistenciaCursoComponent
  },

  {
    path: 'retroalimentacion/report',
    component: RetroalimentacionReportComponent,
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(estudioRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class EstudioRoutingModule { }
